import ImageWithBasePath from "@/components/image-with-base-path"
import { Link } from "react-router"

const OfferSection = () => {
  return (
   <>
  {/* Start What We Offer Section */}
  <section className="section offer-section-fifteen">
    <div className="container">
      {/* start row  */}
      <div className="row row-gap-5">
        <div className="col-lg-6">
          <div
            className="section-header-fifteen wow fadeInUp"
            data-wow-duration="2s"
          >
            <div className="section-sub-title">What We Offer</div>
            <h2 className="section-title">
              Comprehensive Care <br /> for Your <span>Well-Being</span>
            </h2>
            <p className="description">
              We offer a range of therapeutic services designed to support{" "}
              <br />
              your mental health journey, wherever you are in life.
            </p>
            <div className="view-more">
              <Link to="#" className="btn btn-white">
                View All Services{" "}
                <span className="icon">
                  <i>
                    <i className="isax isax-arrow-right-1" />
                  </i>
                </span>{" "}
              </Link>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          {/* Start row */}
          <div className="row row-gap-4">
            <div className="col-xl-12 col-lg-12 col-md-6">
              {/* Item 1 */}
              <div
                className="offers-item-fifteen wow fadeInUp"
                data-wow-duration="2s"
              >
                <div className="offers-overlay">
                  <ImageWithBasePath
                    src="assets/img/category/offer-img-1.jpg"
                    alt="icon"
                    className="overlay-img img-fluid"
                  />
                </div>
                <div className="offers-content">
                  <div>
                    <h3 className="offers-title">Individual Therapy</h3>
                    <p className="offers-description">
                      One on one sessions tailored to your needs and goals. Work
                      through challenges on own pace with support.
                    </p>
                  </div>
                  <ImageWithBasePath
                    src="assets/img/icons/flower-icon.svg"
                    alt="flower"
                    className="img-fluid element-1"
                  />
                  <Link to="#" className="btn-icon" aria-label="View service">
                    <i>
                      <i className="isax isax-arrow-right-1" />
                    </i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-xl-12 col-lg-12 col-md-6">
              {/* Item 2 */}
              <div
                className="offers-item-fifteen wow fadeInUp"
                data-wow-duration="2s"
              >
                <div className="offers-overlay">
                  <ImageWithBasePath
                    src="assets/img/category/offer-img-2.jpg"
                    alt="icon"
                    className="overlay-img img-fluid"
                  />
                </div>
                <div className="offers-content">
                  <div>
                    <h3 className="offers-title">Couples Counseling</h3>
                    <p className="offers-description">
                      Strengthen your relationship and improve communication.
                      Navigate challenges together with expert guidance.
                    </p>
                  </div>
                  <ImageWithBasePath
                    src="assets/img/icons/flower-icon.svg"
                    alt="flower"
                    className="img-fluid element-1"
                  />
                  <Link to="#" className="btn-icon" aria-label="View service">
                    <i>
                      <i className="isax isax-arrow-right-1" />
                    </i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-xl-12 col-lg-12 col-md-6">
              {/* Item 3 */}
              <div
                className="offers-item-fifteen wow fadeInUp"
                data-wow-duration="2s"
              >
                <div className="offers-overlay">
                  <ImageWithBasePath
                    src="assets/img/category/offer-img-3.jpg"
                    alt="icon"
                    className="overlay-img img-fluid"
                  />
                </div>
                <div className="offers-content">
                  <div>
                    <h3 className="offers-title">Anxiety Treatment</h3>
                    <p className="offers-description">
                      Helps manage excessive worry, fear, and panic through
                      proven therapy techniques and coping strategies.
                    </p>
                  </div>
                  <ImageWithBasePath
                    src="assets/img/icons/flower-icon.svg"
                    alt="flower"
                    className="img-fluid element-1"
                  />
                  <Link to="#" className="btn-icon" aria-label="View service">
                    <i>
                      <i className="isax isax-arrow-right-1" />
                    </i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-xl-12 col-lg-12 col-md-6">
              {/* Item 4 */}
              <div
                className="offers-item-fifteen wow fadeInUp"
                data-wow-duration="2s"
              >
                <div className="offers-overlay">
                  <ImageWithBasePath
                    src="assets/img/category/offer-img-4.jpg"
                    alt="icon"
                    className="overlay-img img-fluid"
                  />
                </div>
                <div className="offers-content">
                  <div>
                    <h3 className="offers-title">Anger Management</h3>
                    <p className="offers-description">
                      Helps control anger, improve emotional regulation, and
                      develop healthier communication skills.
                    </p>
                  </div>
                  <ImageWithBasePath
                    src="assets/img/icons/flower-icon.svg"
                    alt="flower"
                    className="img-fluid element-1"
                  />
                  <Link to="#" className="btn-icon" aria-label="View service">
                    <i>
                      <i className="isax isax-arrow-right-1" />
                    </i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-xl-12 col-lg-12 col-md-6">
              {/* Item 5 */}
              <div
                className="offers-item-fifteen wow fadeInUp"
                data-wow-duration="2s"
              >
                <div className="offers-overlay">
                  <ImageWithBasePath
                    src="assets/img/category/offer-img-5.jpg"
                    alt="icon"
                    className="overlay-img img-fluid"
                  />
                </div>
                <div className="offers-content">
                  <div>
                    <h3 className="offers-title">Mindfulness Therapy</h3>
                    <p className="offers-description">
                      Learn relaxation and mindfulness techniques to reduce
                      stress and improve mental clarity of your life
                    </p>
                  </div>
                  <ImageWithBasePath
                    src="assets/img/icons/flower-icon.svg"
                    alt="flower"
                    className="img-fluid element-1"
                  />
                  <Link to="#" className="btn-icon" aria-label="View service">
                    <i>
                      <i className="isax isax-arrow-right-1" />
                    </i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/* End row */}
        </div>
      </div>
      {/* End row  */}
    </div>
    <ImageWithBasePath
      src="assets/img/bg/round-element-5.svg"
      alt=""
      className="img-fluid round-element-5 d-none d-lg-block"
    />
  </section>
  {/* Start What We Offer Section */}
</>

  )
}

export default OfferSection